// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import ViewUI from 'view-design';
import 'view-design/dist/styles/iview.css';
import cascaderMulti from "cascader-multi";
import axios from 'axios'
import VueCropper from 'vue-cropper'

import ElementUI from 'element-ui';
import moment from 'moment'//导入文件
Vue.prototype.$moment = moment;//赋值使用
import 'element-ui/lib/theme-chalk/index.css';
import '@/assets/globalStyle/global.less'
import '@/assets/globalStyle/common.less'
import 'animate.css';
window.isJumpFlag = true

Vue.use(VueCropper)
Vue.use(ElementUI);
Vue.prototype.$axios = axios
Vue.prototype.$store = store
Vue.use(cascaderMulti);

Vue.config.productionTip = false

Vue.use(ViewUI);


/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js